import {Component, OnDestroy, OnInit} from '@angular/core';
import { ImportService } from '@services/import.service';
import { FontAwesomeService } from '@services/font-awesome.service';
import { AccountService } from '@services/account.service';
import { ImportTypeEnum } from '@models/importType.enum';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import { SnackBarComponent } from '@components/snackbar/snackbar.component';
import { MatSnackBar } from '@angular/material';
import {selectDefaultInsurance} from '@store/reducers';
import {takeUntil} from 'rxjs/operators';
import {Store} from '@ngrx/store';
import {AppState, selectUser} from '@store/reducers';
import {User} from '@models/user.interface';
import {Subject} from 'rxjs/Subject';

@Component({
  selector: 'app-address-import',
  templateUrl: './import.component.html',
  styleUrls: ['./import.component.scss']
})
export class ImportComponent implements OnInit, OnDestroy {
  public fileTypes: any[] = [{value: 'JSON', label: 'JSON'}, {value: 'XML', label: 'XML'}, {value: 'CSV', label: 'CSV'}];
  public importTypes: any[] = [{value: 'default', label: 'Freightseeker - CSV'}, {value: 'wgr', label: 'WGR E-handel (Wikinggruppen) - CSV'}];
  public form: FormGroup;
  private unsubscribe: Subject<void> = new Subject();
  private file: File = null;

  constructor(
    private importService: ImportService,
    public faService: FontAwesomeService,
    private accountService: AccountService,
    private fb: FormBuilder,
    private matSnackBar: MatSnackBar,
    private store: Store<AppState>
  ) {
  }

  ngOnInit() {
    this.store.select(selectUser)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe((data: User) => {
        if (data) {
          this.form = this.fb.group({
            text: ['', Validators.required],
            importType: [data.settings.address_import_type, Validators.required],
            type: ['JSON', Validators.required]
          });
          this.form.addControl('updateRecords',
            new FormControl(true)
          );
        }
      });
  }


  public onFileChanged(event): void {
    if (!event.target.files[0]) {
      return;
    }
    this.file = event.target.files[0];
    /*
    this.importService.importFile(
      this.file, this.form.get('importType').value,
      ImportTypeEnum.ADDRESS_BOOK,
      this.form.get('updateRecords').value
    );
     */
  }

  public submitFileUploadForm(): void {
    if (! this.file) {
      this.snackBar('Du måste välja en fil!', true);
      return;
    }

    this.importService.importFile(
      this.file, this.form.get('importType').value,
      ImportTypeEnum.ADDRESS_BOOK,
      this.form.get('updateRecords').value
    );
  }

  public submitForm(): void {
    if (this.form.invalid) {
      Object.keys(this.form.controls).forEach((name) => {
        this.form.get(name).markAsTouched();
      });
      return;
    }

    const value = this.form.value;
    value.text = this.b64EncodeUnicode(value.text);
    /*
    this.accountService.importAddressFile(value.text, value.type).subscribe(
      () => {
        this.form.reset({type: 'json'});
        this.form.markAsUntouched();
        this.snackBar('File imported', false);
      },
      () => {
        this.snackBar('Error in file validation');
      }
    );
     */
  }

  private b64EncodeUnicode(str: string): string {
    return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
      function toSolidBytes(match, p1) {
        return String.fromCharCode(Number('0x' + p1));
      }));
  }

  private snackBar(text: string, isError: boolean = true): void {
    this.matSnackBar.openFromComponent(SnackBarComponent, {
      data: {
        error: isError,
        message: text
      },
      panelClass: 'snackbar-container',
      duration: 3000,
    });
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/address-book/import/import.component.ts